module.exports = __webpack_public_path__ + "img/sm-facebook-o.d5952f7f.svg";